var Files = $.extend(false, BaseModule ,{

    api_route : 'media/files',

    data : {
        module              : 'files',
        page                : 1,
        limit               : 20,
        add_to_album        : 0,
        active_editor       : null,
        add_to_active_editor: 0,
        select_from_library : 0,
        order_by            : 'id:desc',
        view                : 'list',
        pagination          : true
    },

	actions:function(action,id){
		var module_name = this.data.module;
		switch(action){
			case "new":
				this.upload_files(module_name);
				break;
			case "edit":
				GlobalModule.load_entry(id,module_name,action);
				break;
			case "edit-selected":
				GlobalModule.load_entry(id,module_name,action);
				break;
			case "crop":
				this.crop(id);
				break;
			case "edit-upload":case "edit-selected-upload":
				this.edit_upload(id);
				break;
			case "delete": case "delete-selected":
                GlobalModule.delete_entry(id,module_name);
                break;
		}
	},
    upload_files: function (module,action) {
        var m = module.split('-');
        $('.' + module + '-wrapper').hide();

        $.ajax({

            url : API,
            data: { intent : 'upload-entry', module : module},
            success: function (data) {

                $('.' + module + '-filters').hide();
                $('.' + module + '-list').empty();
                $('.' + module + '-form').html(data.markup).show();


                if(window[ucwords(m)].after_load_entry){
                    window[ucwords(m)].after_load_entry();
                }
            }
        });

    },

    after_save_entry:function(){

    },

    after_load_list:function(){
        var module_name = this.data.module,module=this;

        $('.'+module_name+'-list').off('item-selected');
        $('.'+module_name+'-list').on('item-selected',function($e,data, is_checked){

            var selection_container = $(this).closest(".modal-body").data('selectioncontainer');

            if(is_checked === true){

                if(selection_container !=null){
                    var sm = $(this).closest(".modal-body").data('sm'),
                        selection_name = $(this).closest(".modal-body").data('selectionname'),
                        selection_markup = $(sm).html();

                    for(var i in data){

                        if(i == 'image'){
                          var w = $(selection_markup).find('img[src^="/media/placeholder"]').data('width'),
                              h = $(selection_markup).find('img[src^="/media/placeholder"]').data('height');


                          if(w < 100){ w = 300;}
                          if(h < 100){ h = 200;}

                            var counter = 0;
                            while(selection_markup.indexOf( '/media/placeholder?w='+w+'&amp;h='+h )!= -1 && counter ++ < 5000){
                                selection_markup = selection_markup.replace('/media/placeholder?w='+w+'&amp;h='+h,data['dynamic'].replace('%s',w).replace('%s',h));
                            }

                            selection_markup = selection_markup.replace('hotspot-placeholder',data['dynamic'].replace('%s',1200).replace('%s',675));


                            var uniq = Math.floor(Math.random()* 1000000);
                            counter = 0;
                            while(selection_markup.indexOf( '--unique--' )!= -1 && counter ++ < 5000){
                                selection_markup = selection_markup.replace('--unique--' , 'partial-' + uniq );
                            }



                        }else{
                          while(selection_markup.indexOf('data.'+i) != -1 ){
                              selection_markup = selection_markup.replace('data.'+i,data[i]);
                          }
                        }

                    }
                    selection_markup = $(selection_markup);

                    selection_markup.find('.cropper-trigger').show();
                    selection_markup.find('.cropper-trigger').data('src' , data['dynamic'].replace('%s',1200).replace('%s','auto'));                    
                    $(selection_container).prepend(selection_markup);

                }else if(module.data.select_from_library === 1){

                    module.select_from_library(data.id,data.dynamic,data.title);

                }else{

                    module.returnFileUrl(data.url);

                }


            }else{
                $(selection_container).find('input:hidden[name="'+selection_name+'"][value="'+data.id+'"]').closest('.selection-item').remove();
            }

        });


    },

	validate_uploader:function(callback){
		var uploader = $('#multiple-uploader').pluploadQueue();
		 if (uploader.files.length > 0) {
             if (uploader.files.length === (uploader.total.uploaded + uploader.total.failed)) {
				if(this.data.upload_details_required){
					return this.validate_uploaded_files();
				}
				return true;
			}else{
				return false;
			}
        } else {
            alert('You must select at least one file.');
			return false;
        }
		return true;
	},


	add_file_to_album:function(id,thumb,title){

		$('.no-files-row').addClass('hidden-xs-up');

		var file_markup = $($('.file_placeholder').html());

		file_markup.attr('id','file_'+id);
		file_markup.find('img.thumb').attr('src',thumb);
		file_markup.find('input.file_id').val(id);
		file_markup.find('input.file_title').val(title).removeClass('empty');
		file_markup.find('input.file_description').val(title).removeClass('empty');

		$('.albums-files-list').prepend($(file_markup).slideDown('fast'));

		return false;
	},

	select_from_library:function(id,thumb,title){

        var module_name = this.data.module,
            target = this.data.active_uploader,
            $target = $(target),
            w = $target.find('.details img').data('width'),
            h = $target.find('.details img').data('height');

        if(w < 100){
          w = 300;
        }
        if(h < 100){
          h = 200;
        }
        var src = thumb.replace('%s','900').replace('%s','auto')
        thumb = thumb.replace('%s',w).replace('%s',h);

        $target.find('.details').html('<img class="img-fluid img-responsive" src="'+thumb+'" data-src="'+src+'" data-width="'+w+'" data-height="'+h+'" />');
        $target.find('.text-details').html('<span>'+title+'</span>');
        $target.find('.cropper-trigger').show();
        $target.find('.cropper-trigger').data('src', src);

        $target.find('.file_id').val(id);


        $("#"+module_name+"-dialog-list").modal('hide');

		return false;
	},


	singleUploader:function(target){

        var uploader = new plupload.Uploader({
            runtimes        : 'html5,flash,silverlight,browserplus',
            browse_button   : target + '-pickfiles',
            container       : target + '-container',
            drop_element    : target + '-dropzone',
            url             : '/admin/upload',
            headers:{
                'X-CSRF-TOKEN':$('meta[name="csrf-token"]').attr('content')
            },
            filters : {
                max_file_size : '1000mb',
                mime_types: [
                    {title : "Documents", extensions : "pdf,csv,xml"},
                    {title : "Video files", extensions : "mp4"},
                    {title : "Image files", extensions : "jpg,jpeg,gif,png"},
                    {title : "Zip files", extensions : "zip"}
                ]
            }
        });

        uploader.bind('Init', function(up, params) {});

        $('#'+target + '-uploadfiles').click(function(e) {
            uploader.start();
            e.preventDefault();
        });

        uploader.init();

        uploader.bind('FilesAdded', function(up, files) {

            $.each(files, function(i, file) {
                var markup = '	 <div id="' + file.id + '"><p>'+file.name+ '</p>\
								<div class="progress progress-small" style="display:none;height:6px;">\
									<div class="progress-bar" style="width: 0%;"></div>\
								</div>';
                $('#'+target + '-uploaded-files').html(markup);
            });
            up.refresh();

            uploader.start();
        });

        uploader.bind('UploadProgress', function(up, file) {
            $('#' + file.id + " .progress").fadeIn('fast');
            $('#' + file.id + " .progress .progress-bar").width(file.percent + "%");
        });

        uploader.bind('Error', function(up, err) {
            $('#'+target + '-filelist').append("<div>Error: " + err.code +
                ", Message: " + err.message +
                (err.file ? ", File: " + err.file.name : "") +
                "</div>"
            );

            up.refresh();
        });

        uploader.bind('FileUploaded', function(up, file,ee) {
            var response = (JSON.parse(ee.response));

            var width   = $('#' + target + '-container  .details img').data('width'),
                height  = $('#' + target + '-container  .details img').data('height'),
                container = $('#' + target + '-container');

            container.find('.details').html('<img data-width="'+width+'" data-height="'+height+'" src="/tmp/'+width+'/'+height+'/'+response.path+'" data-src="/tmp/'+width+'/'+height+'/'+response.path+'" class="img-fluid" />');
            container.find('.progress').fadeOut('fast');
            
            container.find('.uploader_filename' ).val(response.path);
            container.find('.uploader_original_filename' ).val(file.name);
            container.find('.file_id').val(0);
            container.find('.crop-data').val('[]');

            $('#' + target + ' .cropper-trigger').show();
            $('#' + target + ' .cropper-trigger').data('src', '/tmp/'+file.id+'/900/auto/'+file.name);
            $('#' + target + ' .remove-file-trigger').show();
            $('#' + target + ' .remove-assigned-file').show();


        });

    },

    multipleUploader:function(target){

        var uploader = new plupload.Uploader({
            runtimes        : 'html5,flash,silverlight,browserplus',
            container       : target ,
            browse_button   : target + '-pickfiles',
            drop_element    : target + '-dropzone',
            url             : '/admin/upload',
            headers:{
                'X-CSRF-TOKEN':$('meta[name="csrf-token"]').attr('content')
            },
        
            filters : {
                max_file_size : '1000mb',
                mime_types: [
                    {title : "Documents", extensions : "pdf,csv,xml"},
                    {title : "Video files", extensions : "mp4"},
                    {title : "Image files", extensions : "jpg,jpeg,gif,png"},
                    {title : "Zip files", extensions : "zip"}
                ]
            }
        });

        uploader.bind('Init', function(up, params) {

        });

        $('#'+target + '-uploadfiles').click(function(e) {
            uploader.start();
            e.preventDefault();
        });

        uploader.init();

        uploader.bind('FilesAdded', function(up, files) {
            $('#'+target + '-uploadfiles').show();

            $.each(files, function(i, file) {
                var markup = '<tr class="template-upload" id="' + file.id + '">\
                                  <td class="name">\
                                  <span>'+file.name+' : ' + plupload.formatSize(file.size) + '</span>\
                                  <div class="progress progress-xs" style="display:none;">\
                                    <div class="progress-bar" style="width: 0%;"></div>\
                                  </div>\
                                      <button type="button" class="btn btn-icon btn-flat edit-upload-trigger" data-toggle="tooltip" data-original-title="Edit">\
                                      <i class="icon icon-edit" aria-hidden="true"></i>\
                                      <i class="icon icon-close" style="display:none;" aria-hidden="true"></i>\
                                      </button>\
                                        <button type="button" class="btn btn-sm btn-icon btn-flat btn-default remove-file" data-toggle="tooltip" data-original-title="Delete"><i class="icon icon-delete" aria-hidden="true"></i></button>\
                                  </td>\
						</tr>';
                $('#uploaded-files').closest('table').show();
                $('#uploaded-files').append(markup);
            });
            up.refresh();

            uploader.start();
        });

        uploader.bind('UploadProgress', function(up, file) {
            $('#' + file.id + " .progress").fadeIn('fast');
            $('#' + file.id + " .progress .progress-bar").width(file.percent + "%");
        });

        uploader.bind('Error', function(up, err) {
            $('#'+target + '-filelist').append("<div>Error: " + err.code +
                ", Message: " + err.message +
                (err.file ? ", File: " + err.file.name : "") +
                "</div>"
            );

            up.refresh(); // Reposition Flash/Silverlight
        });

        uploader.bind('FileUploaded', function(up, file,ee) {
            $('#' + file.id + " .progress").fadeOut('fast');
            
            var response = (JSON.parse(ee.response));
            var markup = '';




            markup += '<div class="file-details" style="display: none;">';
            var width   = 50, height  = 50;

            markup += '<img data-width="'+width+'" data-height="'+height+'" src="/tmp/'+width+'/'+height+'/'+response.path+'" data-src="/tmp/'+width+'/'+height+'/'+response.path+'" class="img-fluid" />';
            markup += '<input type="hidden" name="upload_id[]" value="'+file.id+'"/>';
            markup += '<input type="hidden" id="filename-'+file.id+'" name="filename[]" value="'+response.path+'"/>';
            markup += '<input type="hidden" id="original-filename-'+file.id+'" name="original_filename[]" value="'+file.name+'"/>';
            markup += '<div class="form-group form-material floating"><input class="form-control empty" type="text" id="title-'+file.id+'" name="title[]" value=""/> <label  class="floating-label">Title</label></div>';
            markup += '<div class="form-group form-material floating"><input class="form-control empty" type="text" id="alt-'+file.id+'" name="alt[]" value=""/> <label  class="floating-label">Alt </label></div>';
            markup += '<div class="form-group form-material floating"><input class="form-control empty" type="text" id="tags-'+file.id+'" name="tags[]" value=""/> <label  class="floating-label">Tags</label></div>';
            markup += '</div>';
            $('#' + file.id ).addClass('completed');
            $('#' + file.id + " .name").append(markup);

        });

        $(document).on('click','.remove-file',function(e) {
            var id = $(this).closest('tr').attr('id');
            uploader.removeFile(uploader.getFile(id));
            $('#'+id).remove();

            if($('#uploaded-files tr').length == 0){
                $('#'+target + '-savefiles').hide();
            }

            e.preventDefault();
        });

        $(document).on('click','.edit-upload-trigger',function(e) {
            $(this).closest('tr').find('.file-details').toggle();
            $(this).closest('tr').find('.remove-file').toggle();
            $(this).find('i').toggle();
            e.preventDefault();
        });

    },

    // Simulate user action of selecting a file to be returned to CKEditor.
    returnFileUrl : function(fileUrl) {

        var funcNum = getUrlParam( 'CKEditorFuncNum' );
        window.opener.CKEDITOR.tools.callFunction( funcNum, fileUrl, function() {
            // Get the reference to a dialog window.
            var dialog = this.getDialog();
            // Check if this is the Image Properties dialog window.
            if ( dialog.getName() == 'image' ) {
                // Get the reference to a text field that stores the "alt" attribute.
                var element = dialog.getContentElement( 'info', 'txtAlt' );
                // Assign the new value.
                if ( element )
                    element.setValue( 'alt text' );
            }
            // Return "false" to stop further execution. In such case CKEditor will ignore the second argument ("fileUrl")
            // and the "onSelect" function assigned to the button that called the file manager (if defined).
            // return false;
        } );
        window.close();
    },

    init:function(){

		var module_name = this.data.module, module = this;

        $(document).on('click','.remove-assigned-file',function(){
            var target = $(this).data('target');
            $(this).hide();
            $('.select-library-trigger[data-target="'+target+'"]').show();
            $(target).find('.details').empty()
            $(target).find('.text-details').empty();
            $(target).find('.file_id').val(0);
            return false;
        });

        $(document).on('click','.add-files-to-album',function(){
	        module.data.add_to_album = 1;
        	module.data.offset = 24;
        	module.data.view = 'grid';
            module.load_list_dialog('album');
            return false;
        });
	}
});

$(document).ready(function(){
	Files.init();
});

function getUrlParam( paramName ) {
    var reParam = new RegExp( '(?:[\?&]|&)' + paramName + '=([^&]+)', 'i' );
    var match = window.location.search.match( reParam );

    return ( match && match.length > 1 ) ? match[1] : null;
}
